import { useTranslation } from "react-i18next";

const { Row } = require("reactstrap");
const { default: IconInput } = require("../iconInput/IconInput");

const InputList = ({ fields = [], data = {}, onChange }) => {
    const { t } = useTranslation();
    return (
        <Row>
            {fields.map(field => (
                <IconInput
                    key={field.key}
                    options={field.options}
                    label={t(field.label)}
                    iconKey={field.icon}
                    value={data[field.key]}
                    type={field.type}
                    maxRange={field.maxRange}
                    rangeStep={field.rangeStep}
                    onChange={(e) => onChange(field.key, e.target.value)}
                    readOnly={field.readOnly}
                    md={field.md}
                    xl={field.xl}
                />
            ))}
        </Row>
    );
};

export default InputList